import { inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { mapResponse } from '@ngrx/operators';
import { exhaustMap, switchMap } from 'rxjs';
import { MetricService } from '../../../api/services';
import { LoadingState } from '../models/loader.model';
import { metricActions } from './metric.actions';

export const metricLoadManyEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(MetricService)) => {
    return actions$.pipe(
      ofType(metricActions.loadMany),
      switchMap((props) =>
        compService.metricControllerFindAllMetric({ ...props }).pipe(
          mapResponse({
            next: (r) => metricActions.loadManyDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: () =>
              metricActions.loadManyDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: "Impossibile recuperare l'elenco delle metriche." },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);

export const metricLoadModelMetricEffect = createEffect(
  (actions$ = inject(Actions), compService = inject(MetricService)) => {
    return actions$.pipe(
      ofType(metricActions.loadModelMetric),
      exhaustMap((props) =>
        compService.metricControllerFindAllModelMetric({ ...props }).pipe(
          mapResponse({
            next: (r) => metricActions.loadModelMetricDone({ data: r.data, state: { value: LoadingState.SUCCESS } }),
            error: () =>
              metricActions.loadModelMetricDone({
                state: {
                  value: LoadingState.FAIL,
                  message: { severity: 'warn', text: 'Impossibile recuperare le metriche del modello.' },
                },
              }),
          }),
        ),
      ),
    );
  },
  { functional: true },
);
